import React from "react"
import Moment from "moment"
import BonusPointsLayout from "./BonusPointsLayout"
import CustomDataTable from "../shared/CustomDataTable"

const columns = [
  {
    key: 'product',
    label: 'Produto',
    sortKey: 'product',
    render: (_v, item) => item.client_product.external_identifier,
  },
  {
    key: 'total_points',
    label: 'Pontos totais',
    sortKey: 'total_points',
    render: (_v, item) => Number(item.total_points_earned),
  },
  {
    key: 'points_spent',
    label: 'Pontos atribuidos',
    sortKey: 'points_spent',
    render: (_v, item) => Number(item.total_points_spent),
  },
  {
    key: 'points_available',
    label: 'Pontos por atribuir',
    sortKey: 'points_available',
    render: (_v, item) => Number(item.total_points_earned) - Number(item.total_points_spent),
  },
  {
    key: 'last_date',
    label: 'Último carregamento',
    sortKey: 'last_date',
    render: (_v, item) => new Moment(item.last_date).format('DD/MM/YYYY'),
  },
];

const sortFn = (data, sort) => {
  const sorted = [...data];
  sorted.sort((a, b) => {
    let valA, valB;
    switch (sort.key) {
      case 'product':
        valA = (a.client_product.external_identifier || '').toLowerCase();
        valB = (b.client_product.external_identifier || '').toLowerCase();
        break;
      case 'total_points':
        valA = Number(a.total_points_earned);
        valB = Number(b.total_points_earned);
        break;
      case 'points_spent':
        valA = Number(a.total_points_spent);
        valB = Number(b.total_points_spent);
        break;
      case 'points_available':
        valA = Number(a.total_points_earned) - Number(a.total_points_spent);
        valB = Number(b.total_points_earned) - Number(b.total_points_spent);
        break;
      case 'last_date':
        valA = new Date(a.last_date).getTime();
        valB = new Date(b.last_date).getTime();
        break;
      default:
        return 0;
    }
    if (valA < valB) return sort.direction === 'asc' ? -1 : 1;
    if (valA > valB) return sort.direction === 'asc' ? 1 : -1;
    return 0;
  });
  return sorted;
};

const BonusPointsTable = ({ bonusPoints, onOpenAddForm }) => {
  const renderRow = (item, index, className) => {
    const normalizedDate = new Moment(item.last_date);
    const pointsEarned = Number(item.total_points_earned);
    const pointsSpent = Number(item.total_points_spent);

    return (
      <tr key={index} className={`data-table__row ${className}__row`}>
        <td className={`data-table__cell ${className}__cell ${className}__cell--product`}>
          {item.client_product.external_identifier}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--total_points`}>
          {pointsEarned}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--points_spent`}>
          {pointsSpent}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--points_available`}>
          {pointsEarned - pointsSpent}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--last_date`}>
          {normalizedDate.format('DD/MM/YYYY')}
        </td>
      </tr>
    );
  };

  return (
    <BonusPointsLayout onOpenAddForm={onOpenAddForm}>
      <CustomDataTable
        className="bonus-points-table"
        columns={columns}
        data={bonusPoints}
        renderRow={renderRow}
        rowKey={(item, index) => index}
        defaultSort={{ key: 'last_date', direction: 'desc' }}
        sortFn={sortFn}
        emptyMessage="Ainda não se encontram pontos bonus atribuidos"
      />
    </BonusPointsLayout>
  )
}

export default BonusPointsTable
